import { GlobalConfigType } from 'actions/global.config.type'
import { InputType, IVisibleProp } from 'config'
import { store } from 'reducers'

export const defaultInputs = (fieldOrigin: string) => {
  const { globalConfigReducer } = store.getState()
  const loanFieldsProps = globalConfigReducer?.[GlobalConfigType.LoanFields] || {}
  const fieldProperties = (loanFieldsProps[fieldOrigin] || {}) as Record<string, IVisibleProp>

  const inputs: Record<string, InputType> = {}

  Object.keys(fieldProperties).forEach((fieldKey) => {
    inputs[fieldKey] = {
      inputType: 'text',
      ...fieldProperties[fieldKey],
    } as any
  })

  return inputs
}
